import useInterventionRepository from "../../../../../repository/emergency/useInterventionRepository";
import {useEffect, useRef} from "react";
import {Button, TextField} from "@mui/material";
import {Send} from "@mui/icons-material";
import Box from "@mui/material/Box";
import useAlert from "../../../../../use/useAlert";
import useQualityInspectionRepository from "../../../../../repository/emergency/useQualityInspectionRepository";
import QualityInspectionUtils from "../../../../../entity/utils/emergency/QualityInspectionUtils";
import isNull from "../../../../../mixin/isNull";
import {DateTimeFormatter, ZonedDateTime, ZoneId} from "@js-joda/core";

const COMPANY_COMMENT_REQUIRED = "Le champs est vide";

export default function ({interventionId, onSuccess}) {
    const alert = useAlert();
    const interventionRepository = useInterventionRepository();
    const qualityInspectionRepository = useQualityInspectionRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneById(interventionId).select();
    /** @type QualityInspection */
    const qualityInspection = qualityInspectionRepository.findOneById(intervention?.getQualityInspectionId()).select();
    const companyCommentInput = useRef();

    useEffect(() => {
        interventionRepository.findOneById(interventionId).exec();
    }, []);

    const submit = async () => {
        if (companyCommentInput.current.value.length === 0) {
            alert.warning(COMPANY_COMMENT_REQUIRED);
            return;
        }

        const step = "[ Le " + (ZonedDateTime.now(ZoneId.of("Europe/Paris")).format(DateTimeFormatter.ofPattern("dd/MM/yyyy HH:mm"))) + " à l'étape " + QualityInspectionUtils.getCurrentStepAsText(qualityInspection.getCurrentStep()) + " ] ";

        const fullComment =
            isNull(intervention.getCompanyComment())
            || intervention.getCompanyComment().length === 0
                ? step + companyCommentInput.current.value
                : intervention.getCompanyComment() + "\n" + step + companyCommentInput.current.value;

        const success = await interventionRepository.update(interventionId, "company_comment", {
            intervention: {
                company_comment: fullComment
            }
        });

        if (success) onSuccess();
    }

    return (
        <div data-test="let-message-modal">
            <div>
                <TextField
                    fullWidth
                    variant={"standard"}
                    multiline
                    minRows={6}
                    maxRows={8}
                    label={"Transmettre une information"}
                    inputRef={companyCommentInput}
                    data-test="textarea-company-comment"
                />
            </div>
            <Box mt={2}>
                <Button
                    startIcon={<Send/>}
                    variant="contained"
                    size={"large"}
                    fullWidth
                    onClick={submit}
                    data-test="button-send-message"
                >
                    Envoyer
                </Button>
            </Box>
        </div>
    )
}